import colors from 'vuetify/es5/util/colors'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css'


Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: colors.blue.darken1,
                secondary: colors.pink.darken4,
                accent: "#e91e63",
                error: "#f44336",
                warning: "#ffc107",
                info: "#2196f3",
                success: "#4caf50"
            },
            dark: {
                primary: colors.blue.darken2,
                accent: colors.red.darken3,
                secondary: colors.deepPurple.darken4,
                info: colors.teal.lighten1,
                warning: colors.amber.base,
                error: colors.red.darken1,
                success: colors.green.accent3
            }
        },
    },
});
